import script from "./SeventhIhramPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SeventhIhramPage.vue?vue&type=script&setup=true&lang=js"

import "./SeventhIhramPage.vue?vue&type=style&index=0&id=4b9e7e0a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b9e7e0a"]])

export default __exports__